import { date } from 'quasar'
import FreshDeskTicketListFilterModel from '../freshdeskticketlistfiltermodel-dialog-screen.vue';

export default {

    data: function () {
        return {
            loading: false,
            modelId: this.$route.params.id ?? 0, // Parent Model ID,
            model: {},
            channelSettings: {
                ApplicationId: 0
            },
            columns: [
                {
                    name: 'Id',
                    label: 'Id',
                    align: 'left',
                    field: row => row.Id,
                    sortable: false,
                    style: '',

                },
                {
                    name: 'ExternalId',
                    label: 'Ticket Id',
                    align: 'left',
                    field: row => row.ExternalId,
                    sortable: true,
                    style: '',

                },
                {
                    name: 'Status',
                    label: 'Status',
                    align: 'left',
                    field: row => row.Status,
                    sortable: true,
                    style: '',

                },
                {
                    name: 'TimeSpent',
                    label: 'Time Spent, hrs',
                    align: 'left',
                    field: row => row.TimeSpent,
                    sortable: false,
                    style: '',

                },
                {
                    name: 'LastTicketUpdate',
                    label: 'Updated At',
                    align: 'left',
                    field: row => row.LastTicketUpdate,
                    sortable: true,
                    style: '',
                    format: (val, row) => date.formatDate(val, 'MM/DD/YYYY h:mm tt'),
                },
                {
                    name: 'Actions',
                    label: 'Actions',
                    align: 'center',
                    field: row => row.Actions,
                    sortable: false,
                    style: ''
                },

            ],
            columnsVisible: ['ExternalId', 'Status', 'TimeSpent', 'LastTicketUpdate', 'Actions'],
            dataSource: [],

            filter: null,
            advancedFilter: null,
            selected: [],
            pagination: {
                sortBy: 'LastTicketUpdate',
                descending: true,
                page: 1,
                rowsPerPage: 15,
                rowsNumber: 0 // Need for 'QTable Request' event
            },
        }
    },

    methods: {
        onRequest(props) {
            this.onLoadListDataSource({
                page: props.pagination.page,
                pageSize: props.pagination.rowsPerPage,
                filter: props.filter,
                advancedFilter: this.advancedFilter,
                sortBy: props.pagination.sortBy,
                descending: props.pagination.descending
            });
        },

        onClearFilterActionClick() {
            this.filter = null;
            this.advancedFilter = null;
            this.pagination.page = 1;
            this.refreshScreen();
        },

        async refreshScreen() {
            if (this.channelSettings.ApplicationId > 0) {
                await this.onLoadListDataSource({
                    page: this.pagination.page,
                    pageSize: this.pagination.rowsPerPage,
                    filter: this.filter,
                    advancedFilter: this.advancedFilter,
                    sortBy: this.pagination.sortBy,
                    descending: this.pagination.descending
                });
            } else {
                this.dataSource = [];
            }
        },

        onAdvancedFilterActionClick() {
            this.$q.dialog({
                component: FreshDeskTicketListFilterModel,
                parent: this,
                index: 0,
                modelId: null,
                modelObject: this.advancedFilter,
                actionLabel: 'Apply',
                actionTitle: '',
                editMode: true
            }).onOk((payload) => {
                this.advancedFilter = payload.model;
                this.pagination.page = 1;
                this.refreshScreen();
            });
        },

        onOpenTicketActionClick(rowKey, rowIndex, row) {
            this.onFreshDeskTicketOpenServerActionDataSource({
                id: rowKey,
                dialogData: null,
                dialogFiles: null

            });
        },

        async onLoadListDataSource(params) {
            try {
                this.loading = true;

                let startRow = (params.page - 1) * params.pageSize;
                let fetchCount = params.pageSize;

                let requestBody = {
                    Skip: startRow,
                    Take: fetchCount + 1,
                    Filter: params.filter,
                    AdvancedFilter: params.advancedFilter,
                    OrderBy: params.sortBy ? params.sortBy : 'Id',
                    OrderByDescending: params.descending
                };

                let response = await this.$http.post('/api/ui/freshdesk_tickets/byApplication/' + this.channelSettings.ApplicationId, requestBody);
                let listViewDataSource = response.body;

                this.dataSource.splice(0, this.dataSource.length, ...listViewDataSource.Rows);

                if (response.body.Metadata) {
                    this.model = response.body.Metadata;
                }

                this.pagination.page = params.page;
                this.pagination.rowsPerPage = params.pageSize;
                this.pagination.sortBy = params.sortBy;
                this.pagination.descending = params.descending;

                if (listViewDataSource.TotalRows) {
                    this.pagination.rowsNumber = listViewDataSource.TotalRows;
                }
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },

        async onFreshDeskTicketOpenServerActionDataSource(params) {
            try {
                this.$q.loading.show({
                    message: 'In progress...'
                });

                // Request from grid row.
                let url = this.$prepareServerUrl('/api/ui/freshdesk_tickets/open/{id}', params.id, params.params, null);
                let response = await this.$http.post(url, params.dialogData, {});

                this.$processServerJsonResponse(response.body, this.refreshScreen);
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.$q.loading.hide();
            }
        },

        onLoadFieldDataSources() {

        },
    },

    computed: {
        screenTitle: function () {
            return 'Billable Support Tickets';
        },
    },

    watch: {
        channelSettings: 'refreshScreen'
    }
}